import { useQuery } from '@apollo/client';
import useLanguage from 'hooks/useLanguage';
import { QUERY } from 'interfaces/graph';
import { actionsPersist, usePersistDispatch } from 'providers/PersistProvider';

export default function useAllPlanSetups() {
	const { language } = useLanguage();
	const dispatchPersist = usePersistDispatch();

	// TODO: handle errors like can't use QUERY GET
	const { loading, error, data } = useQuery(QUERY.ALL_PLAN_SETUPS, {
		fetchPolicy: 'cache-and-network',
		context: {
			headers: {
				'Accept-Language': language
			}
		},
		onCompleted: ({ allPlanSetups }) => {
			dispatchPersist({ type: actionsPersist.updatePersistArray, payload: allPlanSetups });
		}
	});

	return {
		loading: loading || !data || error,
		allPlanSetups: data?.allPlanSetups ?? []
	};
}
